import { atom } from 'recoil'
import { PortalContatoClienteModel, PortalContatoModel } from '@/domain/models'

export const contatoClientesSelectState = atom({
  key: 'contatoClientesSelectState',
  default: [] as PortalContatoClienteModel[]
})

export const contatoClienteSelectedState = atom({
  key: 'contatoClienteSelectedState',
  default: {} as PortalContatoClienteModel
})

export const portalContatoState = atom({
  key: 'portalContatoState',
  default: {} as PortalContatoModel
})

export const isLoadingContatoClientesState = atom({
  key: 'isLoadingContatoClientesState',
  default: false
})
